export default "__VITE_ASSET__735cc414__"